import { _axios } from '@/plugins/axios';

const claimsResource = '/api/v1/claims';

export default {
  all: inScopeRequirementId => _axios.get(`${claimsResource}/mapped/${inScopeRequirementId}`),
  create: claim => _axios.post(`${claimsResource}/create`, claim),
  delete: id => _axios.delete(`${claimsResource}/delete/${id}`),
  update: claim => _axios.put(`${claimsResource}/update`, claim),
  getMappedClaims: reqId => _axios.get(`${claimsResource}/mapped/${reqId}`),
  getScores: () => _axios.get(`${claimsResource}/scores`),
  getSubClaimsCount: claimId => _axios.get(`/api/v1/sub-claims/mapped/${claimId}`),
  checkDuplicateName: title => _axios.get(`${claimsResource}/check-duplicate-name/${title}`),
};
